import moment from 'moment'

export const getGroupByNumber = function (timestring: string, type: string) {
    const date = moment(timestring)

    switch (type) {
        case 'day':
            return date.weekday()
        case 'week':
            return parseInt(timestring.substring(timestring.indexOf('-') + 1), 10)
        case 'month':
            const monthArray = timestring.split('-')
            const monthWithZero = monthArray[1]
            const monthWithoutZero = monthWithZero.replace('0', '')

            return parseInt(monthWithoutZero)
    }
}
